import { DialogContent, Stack } from "@mui/material";
import {
  BottomSheet,
  Illustration,
  Text,
  Title,
  type UseModalState,
} from "@src/appV2/redesign/system/ui-components";

import { DialogFooter } from "../../components/DialogFooter";
import { LoadingButton } from "../../components/LoadingButton";

export interface ShortLeadTimeShiftBookedBottomSheetProps {
  modalState: UseModalState;
  workplaceName: string;
  onGetDirectionsClick?: () => void;
  directionsHref?: string;
}

export function ShortLeadTimeShiftBookedBottomSheet(
  props: ShortLeadTimeShiftBookedBottomSheetProps
) {
  const { modalState, onGetDirectionsClick, workplaceName, directionsHref } = props;

  return (
    <BottomSheet
      modalState={modalState}
      footer={
        <DialogFooter orientation="vertical" sx={{ marginTop: 10 }}>
          <LoadingButton
            fullWidth
            variant="contained"
            size="large"
            href={directionsHref}
            isLoading={false}
            onClick={onGetDirectionsClick}
          >
            Get directions
          </LoadingButton>
        </DialogFooter>
      }
    >
      <DialogContent sx={{ backgroundColor: "unset", py: 8, mt: 8 }}>
        <Stack direction="column" alignItems="center" spacing={9}>
          <Illustration type="shift-booked" />
          <Title variant="h2" component="h2" sx={{ textAlign: "center" }}>
            See you soon!
          </Title>

          <Stack spacing={1} sx={{ textAlign: "center" }}>
            <Text variant="body1" sx={(theme) => ({ color: theme.palette.text.secondary })}>
              {workplaceName} is counting on you!
            </Text>
            <Text variant="body1" sx={(theme) => ({ color: theme.palette.text.secondary })}>
              Please leave home as soon as possible.
            </Text>
          </Stack>
        </Stack>
      </DialogContent>
    </BottomSheet>
  );
}
